import classNames from "classnames"
import s from '../../index.module.css';
import common from './common.module.css';
import Button from "@UI/New/Button";
import useRoles from "@/hooks/useRoles";
import { useEffect, useState } from "react";
import { timetableAPI, timetableBeta } from "@/api";
import Preloader from "@UI/Preloader";
import { ContentForAdmin } from "./components/ContentForAdmin";
import { ContentForChildren } from "./components/ContentForChildren";
import { ContentForSeminarian } from "./components/ContentForSeminarian";
import setSettingsFromServer from "@/helpers/setSettingsFromServer";
import { useDispatch } from "react-redux";
import { closeAllModal } from "@store/modalsSlise";
import { getLinkToMeeting } from "@/helpers/new/getLinkToMeeting";

const ShowLessonOrMeeting = ({ data }) => {
    const dispatch = useDispatch();
    const closeModal = () => {
        dispatch(closeAllModal());
    }
    const [settings, setSettings] = useState(null);
    useEffect(() => {
        setSettingsFromServer(setSettings)
    }, []);
    const isTeacherArrivalTimeForTheMeeting = settings?.isTeacherArrivalTimeForTheMeeting === '1';
    
    const { isAdminOrJuniorAdmin, isSeniorSeminarian, isChildrenOrParent, isSeminarian } = useRoles();

    const [state, setState] = useState({});
    
    const [loading, setLoading] = useState(true);
    useEffect(()=>{
        timetableBeta.getReport({id: data.report_id})
            .then(({data})=>{
                if(data.status === 'success'){
                    setState(data?.data)
                }
            })
            .finally(()=> setLoading(false))
    }, [data.report_id])

    const goToMeeting = () => {
        if((!isSeminarian) || (state?.opened_at) || !isTeacherArrivalTimeForTheMeeting || !state?.id) {
            return;
        }

        timetableAPI.saveTimeOpeningLessonFirstTime({id: state.id})
        .then(({data})=>{
            setState((prev)=>({...prev, opened_at: data?.entry_time}))
        })
    }

    if(loading){
         return (
            <div className={classNames(s.modalContainer, common.preloader, common.modalContainer)}>
               <Preloader /> 
            </div>
        )
    }
    return (
        <div className={classNames(s.modalContainer, common.modalContainer)}>
            <div className={s.modalHeader}>
            <div className={s.modalTitleContainer}>
                <span className={s.modalHeaderBigTitle}>
                    {state?.directionName}
                </span>
            </div>
            </div>
            <div className={classNames(s.contentWrapper, common.contentWrapper)}>
                {
                    (isAdminOrJuniorAdmin || isSeniorSeminarian) && <ContentForAdmin report={state} />
                }
                {
                    isSeminarian && <ContentForSeminarian report={state} />
                }
                {
                    isChildrenOrParent && <ContentForChildren report={state} />
                }
                <div className={common.row}>
                     <Button 
                            color='gray'
                            onClick={closeModal}
                            className={common.button}>
                            Закрыть
                    </Button>
                    {
                        !!getLinkToMeeting({report: state}) && (
                            <a href={getLinkToMeeting({report: state})} target="_blank" rel="noreferrer">
                                <Button 
                                        color='secondary'
                                        onClick={goToMeeting}
                                        className={common.button}>
                                        Перейти на встречу
                                </Button>
                            </a>
                        )
                    } 
                </div>
            </div>
        </div>
    )
}
export default ShowLessonOrMeeting;